import {
    PROVINCE_LIST_ACTION, PROVINCE_LIST_SUCCESS,
    FLIGHT_CONFIG_GET, FLIGHT_CONFIG_UPDATE, FLIGHT_CONFIG_SUCCESS,
    EXCHANGE_RATE_LIST_ACTION, EXCHANGE_RATE_LIST_SUCCESS,
    EXCHANGE_RATE_UPDATE_ACTION, EXCHANGE_RATE_UPDATE_SUCCESS,
} from '../constants/Types';

export const getListProvinces = (countryCode) => ({ type: PROVINCE_LIST_ACTION, countryCode });
export const setListProvinces = (provinces) => ({ type: PROVINCE_LIST_SUCCESS, provinces });

export const getFlightConfig = () => ({ type: FLIGHT_CONFIG_GET });
export const updateFlightConfig = (flightConfig) => ({ type: FLIGHT_CONFIG_UPDATE, flightConfig });
export const setFlightConfig = (flightConfig) => ({ type: FLIGHT_CONFIG_SUCCESS, flightConfig });

export const getListExchangeRates = () => ({ type: EXCHANGE_RATE_LIST_ACTION });
export const setListExchangeRates = (exchangeRates) => ({ type: EXCHANGE_RATE_LIST_SUCCESS, exchangeRates });
export const updateExchangeRate = (exchangeRate) => ({ type: EXCHANGE_RATE_UPDATE_ACTION, exchangeRate });
export const setExchangeRate = (exchangeRate) => ({ type: EXCHANGE_RATE_UPDATE_SUCCESS, exchangeRate });